/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import BaseCom from "./BaseCom";
import Webcam from "react-webcam";
import * as React from "react";

export default class WoundCapture extends BaseCom {

    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.onCapture = props.onCapture;
        this.onCancel = props.onCancel;
        this.onMedia = this.onMedia.bind(this);
        this.tick = this.tick.bind(this);
    }

    componentDidMount() {
        if (!this.interval)
            this.interval = setInterval(this.tick, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        this.interval = null;
    }

    tick() {
        var scrn = this.ref.current.getScreenshot();
    }

    onMedia(data) { 

    }

    render() {
        return <>
            <Webcam
                audio={false}
                screenshotFormat="image/png"
                width="100%"
                onUserMedia={this.onMedia}
                ref={this.ref}
            />
            <div className="btn-group p-2"><button type="button" onClick={this.onCancel} className="btn btn-secondary">Cancel Capture</button></div>
        </>;
    }
}